// extracted by mini-css-extract-plugin
export default {"systemBox":"TestConnection_systemBox__4sZsb","testsBox":"TestConnection_testsBox__eWWCe","tableBox":"TestConnection_tableBox__Mo+9+"};